//auth
export const LOGIN = 'LOGIN';

//job
export const GET_JOBS = 'GET_JOBS';
export const GET_PROJECTS = 'GET_PROJECTS';

//master
export const GET_PROVINCES = 'GET_PROVINCES';
export const GET_SENSOR_TYPES = 'GET_SENSOR_TYPES';
